var _dec, _class, _AudioSignal, _RecordingBadge;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import { connect } from 'react-redux';
import { withStyle, jsx } from '@instructure/emotion';
import AudioSignal from '../AudioSignal';
import { LOADING, PREVIEWSAVE } from '../../../constants/CaptureStates';
import generateStyle from './styles';
import RecordingBadge from '../RecordingBadge';

/**
---
private: true
---
**/
let AudioSignalContainer = (_dec = withStyle(generateStyle), _dec(_class = class AudioSignalContainer extends Component {
  componentDidMount() {
    this.props.makeStyles();
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  render() {
    const _this$props = this.props,
      styles = _this$props.styles,
      captureState = _this$props.captureState;
    switch (captureState) {
      case LOADING:
      case PREVIEWSAVE:
        return null;
      default:
        return jsx("div", {
          css: styles.container
        }, _AudioSignal || (_AudioSignal = jsx(AudioSignal, null)), _RecordingBadge || (_RecordingBadge = jsx(RecordingBadge, null)));
    }
  }
}) || _class);
const mapStateToProps = state => ({
  captureState: state.captureState
});
export default connect(mapStateToProps)(AudioSignalContainer);